var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/role-has-required-aria-props */
import React from 'react';
import cn from 'classnames';
import { Icon } from '@cb/apricot-react-icon';
export const HighlightedString = (_a) => {
    var { sourceString, matcherString } = _a, props = __rest(_a, ["sourceString", "matcherString"]);
    const sourceStr = sourceString !== null && sourceString !== void 0 ? sourceString : '';
    const matcherStr = matcherString ? matcherString === null || matcherString === void 0 ? void 0 : matcherString.trim() : '';
    const firstI = sourceStr === null || sourceStr === void 0 ? void 0 : sourceStr.toLowerCase().indexOf(matcherStr.toLowerCase());
    const initial = sourceStr.slice(0, firstI);
    const last = sourceStr.slice(firstI + matcherStr.length, sourceStr.length);
    const middle = sourceStr.slice(firstI, firstI + matcherStr.length);
    if (firstI === -1 || matcherString === '' || sourceStr === '') {
        return React.createElement("span", null, sourceStr);
    }
    return (React.createElement("p", Object.assign({}, props),
        initial,
        React.createElement("span", { className: "cb-font-weight-bold" }, middle),
        last));
};
export const DropdownItem = ({ label, value, icon, dropDownItemIconLeft = false, searchValue, highlightInputValue, dropDownItemAnchorAttributes, onClickDropdownItem, dropDownItemClassNameFunc, dropDownItemFunc, }) => {
    const attributesArray = (attributes) => {
        return attributes.reduce((attrib, [aName, aValue]) => (Object.assign(Object.assign({}, attrib), { [aName]: aValue })), {});
    };
    return (React.createElement("li", { role: "presentation", className: cn(dropDownItemClassNameFunc && dropDownItemClassNameFunc(label, value)) },
        React.createElement("a", Object.assign({ href: "/#", role: "option", onClick: e => {
                e.preventDefault();
                onClickDropdownItem && onClickDropdownItem(e, label, value);
            }, onKeyDown: e => {
                onClickDropdownItem && onClickDropdownItem(e, label, value);
            }, className: cn(dropDownItemIconLeft && icon && 'justify-content-start') }, (dropDownItemAnchorAttributes && attributesArray(dropDownItemAnchorAttributes))), dropDownItemFunc ? (React.createElement(React.Fragment, null, dropDownItemFunc(label, value, searchValue))) : (React.createElement(React.Fragment, null,
            dropDownItemIconLeft && icon && React.createElement(Icon, { name: icon, decorative: true, className: "cb-margin-right-8" }),
            !highlightInputValue ? (React.createElement("span", null, label)) : (React.createElement(HighlightedString, { sourceString: label, matcherString: searchValue })),
            !dropDownItemIconLeft && icon && React.createElement(Icon, { name: icon, decorative: true }))))));
};
//# sourceMappingURL=DropdownItem.js.map